import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SanitizerService {

  constructor(private sanitizer: DomSanitizer) { }

  sanitizeData(source: string): string {
    let result: string | null = this.sanitizer.sanitize(SecurityContext.HTML, source);

    return result === null ? "" : this.escapeHtml(result);
  }

  private escapeHtml(source: string): string {
    let div = document.createElement('div');
    div.innerHTML = source;
    return div.innerText;
  }
}
